module.exports = __webpack_public_path__ + "static/media/sass.dd2714a1.png";